import type { Nullable } from '@silverhand/essentials';
import type { TFuncKey } from 'i18next';

import ConnectIcon from '@/assets/icons/connect-icon.svg?react';
import { cn } from '@/lib/utils';
import DynamicT from '@/shared/components/DynamicT';

import styles from './index.module.scss';

export type Props = {
  readonly className?: string;
  readonly logo?: Nullable<string>;
  readonly thirdPartyLogo?: Nullable<string>;
  readonly title?: TFuncKey;
  readonly titleInterpolation?: Record<string, unknown>;
  readonly headline?: TFuncKey;
  readonly headlineInterpolation?: Record<string, unknown>;
};

const BrandingHeader = ({
  logo,
  thirdPartyLogo,
  title,
  titleInterpolation,
  headline,
  headlineInterpolation,
  className,
}: Props) => {
  const shouldConnectSvg = Boolean(thirdPartyLogo && logo);

  return (
    <div className={cn('w-full flex flex-col items-start gap-2 mb-7 text-left', className)}>
      {/* Third-party (OAuth consent) logo only — the app-brand logo is rendered by AppLayout's top bar */}
      {thirdPartyLogo && (
        <div className={styles.logoWrapper}>
          <img className={styles.logo} alt="third party logo" src={thirdPartyLogo} />
          {shouldConnectSvg && <ConnectIcon className={styles.connectIcon} />}
        </div>
      )}

      {title && (
        <h2 className={cn('text-3xl font-semibold tracking-tight text-card-foreground')}>
          <DynamicT forKey={title} interpolation={titleInterpolation} />
        </h2>
      )}

      {headline && (
        <p className={cn('text-sm text-muted-foreground py-5')}>
          <DynamicT forKey={headline} interpolation={headlineInterpolation} />
        </p>
      )}
    </div>
  );
};

export default BrandingHeader;
